import { HomeOfferModel } from "./home-offer.model";

export const IOfferSlidersProperties = Object.freeze({
  contractType: "contract_type",
  offers: "offers",
});

export class OffersSliderPropertiesModel {
  constructor(data = {}) {
    this[IOfferSlidersProperties.contractType] = data[IOfferSlidersProperties.contractType];
    this[IOfferSlidersProperties.offers] = data[IOfferSlidersProperties.offers];
  }

  getContractType() {
    return this[IOfferSlidersProperties.contractType];
  }

  getMatchedOffers() {
    return (this[IOfferSlidersProperties.offers] || []).map((offer) => new HomeOfferModel(offer));
  }
}
